import axios from 'axios';

const baseUrl = process.env.REACT_APP_BACKEND_DOMAIN;

export default class Announcement {
  static endpoints = {
    index: `${baseUrl}/announcements`,
  };

  static paginators = {
    all: (data)=> axios.get(this.endpoints.index, {params: data}).then((response)=> response.data.announcements.items),
  }
}